import { useFrame } from "@react-three/fiber"

import { isOnElectionPortal } from "../../lib/domeConstants"
import { usePlayerStore } from "../../stores/usePlayerStore"

// 2026-05-06 — Sensor de proximidad al portal dorado.
//
// Vive dentro del Canvas (necesita useFrame). En cada frame chequea
// si el avatar local está dentro del círculo de proximidad del
// portal. Cuando entra/sale, actualiza la bandera global
// `isOnElectionPortal`; el overlay UI 2D
// (`ElectionPortalPrompt`) lee esa bandera y muestra el modal de
// reconfiguración cuando es true.
//
// Sólo activo cuando el Tripulante está incarnated (no tiene sentido
// medir proximidad mientras está en void / descendiendo). El reset a
// false al salir de incarnated evita prompts colgados después de un
// toggle de fase.

export function ElectionPortalSensor() {
    useFrame(() => {
        const state = usePlayerStore.getState()
        if (state.phase !== "incarnated") {
            if (state.isOnElectionPortal) state.setOnElectionPortal(false)
            return
        }
        const [x, , z] = state.position
        const next = isOnElectionPortal(x, z)
        if (next !== state.isOnElectionPortal) {
            state.setOnElectionPortal(next)
        }
    })
    return null
}
